import { createAction, props } from '@ngrx/store';
import {
  TipoContrato,
  CreateTipoContratoRequest,
  UpdateTipoContratoRequest
} from '../models/tipo-contrato.interface';

// Load Tipos Contrato
export const loadTiposContrato = createAction(
  '[TipoContrato] Load Tipos Contrato',
  props<{ force?: boolean }>()
);

export const loadTiposContratoSuccess = createAction(
  '[TipoContrato] Load Tipos Contrato Success',
  props<{ tiposContrato: TipoContrato[] }>()
);

export const loadTiposContratoFailure = createAction(
  '[TipoContrato] Load Tipos Contrato Failure',
  props<{ error: string }>()
);

// Create Tipo Contrato
export const createTipoContrato = createAction(
  '[TipoContrato] Create Tipo Contrato',
  props<{ tipoContrato: CreateTipoContratoRequest }>()
);

export const createTipoContratoSuccess = createAction(
  '[TipoContrato] Create Tipo Contrato Success',
  props<{ tipoContrato: TipoContrato }>()
);

export const createTipoContratoFailure = createAction(
  '[TipoContrato] Create Tipo Contrato Failure',
  props<{ error: string }>()
);

// Update Tipo Contrato
export const updateTipoContrato = createAction(
  '[TipoContrato] Update Tipo Contrato',
  props<{ id: number; tipoContrato: UpdateTipoContratoRequest }>()
);

export const updateTipoContratoSuccess = createAction(
  '[TipoContrato] Update Tipo Contrato Success',
  props<{ tipoContrato: TipoContrato }>()
);

export const updateTipoContratoFailure = createAction(
  '[TipoContrato] Update Tipo Contrato Failure',
  props<{ error: string }>()
);

// Delete Tipo Contrato
export const deleteTipoContrato = createAction(
  '[TipoContrato] Delete Tipo Contrato',
  props<{ id: number }>()
);

export const deleteTipoContratoSuccess = createAction(
  '[TipoContrato] Delete Tipo Contrato Success',
  props<{ id: number }>()
);

export const deleteTipoContratoFailure = createAction(
  '[TipoContrato] Delete Tipo Contrato Failure',
  props<{ error: string }>()
);

// Search Tipos Contrato
export const searchTiposContrato = createAction(
  '[TipoContrato] Search Tipos Contrato',
  props<{ query: string }>()
);

export const searchTiposContratoSuccess = createAction(
  '[TipoContrato] Search Tipos Contrato Success',
  props<{ results: TipoContrato[] }>()
);

export const clearTipoContratoSearch = createAction('[TipoContrato] Clear Search');

// Select Tipo Contrato
export const selectTipoContrato = createAction(
  '[TipoContrato] Select Tipo Contrato',
  props<{ tipoContrato: TipoContrato | null }>()
);

// Clear Error
export const clearTipoContratoError = createAction('[TipoContrato] Clear Error');
